import { useVisitedOffersContext } from '@cian/frontend-visited-offers-widget';

import { useCallback } from 'react';

import { useGetAnalyticsPage } from '@/app/shared/hooks/useGetAnalyticsPage';

import { useCardOfferContext } from '@/microfrontends/listing/shared/context/selectors';

import { useCAForCard } from './useCAForCard';

export function useCardClickAction(): () => void {
  const caForCard = useCAForCard();
  const { setOfferVisited } = useVisitedOffersContext();
  const {
    data: { url },
    id: offerId,
  } = useCardOfferContext();
  const { pageType, listingType } = useGetAnalyticsPage();

  return useCallback(() => {
    caForCard({ action: 'to_card', category: 'Listing', label: 'card_detail_in_newlist' });

    setOfferVisited(offerId);

    window.open(`${url}?source=${pageType}&listingType=${listingType}`, '_blank');
  }, [caForCard, setOfferVisited, offerId, url, pageType, listingType]);
}
